import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { useIntl } from 'react-intl';

import UserSelectItem from '../ModalUserSelectItem';
import SelectVirtualMenuList from '../SelectVirtualMenuList';

const UsersFilter = ({
  selectedUser,
  defaultSelectedUser,
  loading: mainLoading,
  loadUsers,
  handleChangeUser,
}) => {
  const intl = useIntl();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    loadUsers().then((response) => {
      const { data } = response;
      if (data) {
        setUsers(data);

        if (defaultSelectedUser) {
          const defaultSelectedUserObject =
            data.find(user => user.uuid === defaultSelectedUser.uuid);
          if (defaultSelectedUserObject) {
            handleChangeUser(defaultSelectedUserObject);
          }
        }
      }
      setLoading(false);
    });
  }, [loadUsers, defaultSelectedUser, handleChangeUser]);

  const getUsersOptions = () => {
    const options = [];
    users
      .forEach((user) => {
        options.push({
          uuid: user.uuid,
          email: user.email,
          name: user.name,
          avatar: user.avatar_url,
        });
      });

    return options;
  };

  if (users.length === 0 && !loading) {
    return null;
  }

  return (
    <div className="filter users-filter-container">
      <Select
        id="users-filter"
        inputId="users-filter-input"
        name="filterUser"
        className="user-select"
        classNamePrefix="user-select"
        placeholder={loading ? intl.formatMessage({ defaultMessage: 'Loading...' }) :
          intl.formatMessage({ defaultMessage: 'Select a user' })}
        noOptionsMessage={() => (intl.formatMessage({ defaultMessage: 'No users' }))}
        getOptionValue={option => option.email}
        getOptionLabel={option => option.name}
        components={{
          Option: UserSelectItem,
          MenuList: SelectVirtualMenuList,
        }}
        isDisabled={loading || mainLoading}
        isLoading={loading}
        options={getUsersOptions()}
        onChange={handleChangeUser}
        value={selectedUser}
        isOptionSelected={(option, value) => {
          if (value[0]) {
            return option.uuid === value[0].uuid;
          }
          return false;
        }}
        isClearable={true}
      />
    </div>
  );
};

UsersFilter.propTypes = {
  selectedUser: PropTypes.object,
  defaultSelectedUser: PropTypes.object,
  loading: PropTypes.bool,
  handleChangeUser: PropTypes.func.isRequired,
  loadUsers: PropTypes.func.isRequired,
};

UsersFilter.defaultProps = {
  selectedUser: null,
  defaultSelectedUser: null,
  loading: false,
};

export default UsersFilter;
